import { Switch as ArkSwitch } from '@ark-ui/react'
import { cn } from '@/utlis/cn'

type SwitchProps = {
    label?: string
    checked?: boolean
    onChange?: (checked: boolean) => void
    className?: string
}
export function Switch(props: SwitchProps) {
    const controlBase =
        'relative w-[50px] h-[24px] flex items-center rounded-full cursor-pointer transition-all duration-300 ease-in-out'
    const controlBg = 'bg-neutral-900 data-[state=checked]:bg-muse-primary-gradient'

    const thumbBase = 'block absolute w-[18px] h-[18px] rounded-full transition-all duration-300 ease-in-out'
    const thumbBg = 'bg-neutral-700 data-[state=checked]:bg-neutral-200'
    const thumbPos = 'left-1 data-[state=checked]:left-[calc(100%-18px-var(--spacing))]'

    return (
        <ArkSwitch.Root
            checked={props.checked}
            onCheckedChange={(e) => props.onChange?.(e.checked)}
            className={cn('flex items-center gap-2', props.className)}
        >
            {props.label && <ArkSwitch.Label className="cursor-pointer">{props.label}</ArkSwitch.Label>}
            <ArkSwitch.Control className={cn(controlBase, controlBg)}>
                <ArkSwitch.Thumb className={cn(thumbBase, thumbBg, thumbPos)} />
            </ArkSwitch.Control>
            <ArkSwitch.HiddenInput />
        </ArkSwitch.Root>
    )
}
